import React from 'react';
import './LambLoader.css';
import lambLogo from '/apple-touch-icon.png';

export const LambLoader = ({ message, height = '100vh' }) => (
  <div className="lamb-loader" style={{ height }}>
    <div className="lamb-loader-content">
      <img
        src={lambLogo}
        alt="Little Lamb English"
        className="lamb-logo"
      />
      {message !== '' && <div className="lamb-message">{message || '小羊英语'}</div>}
      <div className="lamb-dots">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  </div>
);
